<!--
 * @Desc: 项目入口文件
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: 赵佳明
 * @LastEditTime: 2023-02-03 09:49:20
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved.
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { getIsMobile, isPC } from '@/utils/device';
import { pageApi } from '@/api';
export default {
  name: 'App',
  data() {
    return {
      active_page: '', // 当前页面路径
      isLogin: false, // 登录状态,
      windowWidth: window.innerWidth, // 添加窗口宽度响应式数据
    };
  },
  beforeMount() {
    const isPhone = getIsMobile();
    this.setRem(isPhone);
    window.addEventListener('resize', this.setRem); // 监听屏幕大小变化
  },
  mounted() {
    this.setRem();
    window.addEventListener('resize', this.setRem); // 监听屏幕大小变化
  },
  async created() {
    this.active_page = this.$route.path;
    this.setRem();
    window.addEventListener('resize', () => {
      this.setRem();
      this.listenMobile();
    });
    await this.getSign();

    console.log(wx, 'wx');
    wx.ready(function () {
      // 分享给朋友
      wx.updateAppMessageShareData({
        title: '山木枝（河北）技术服务有限公司',
        desc: '开发 + 设计 创新未来价值为企业打造高效的数字营销路径，实现可持续增长',
        link: window.location.href,
        imgUrl: 'http://www.shanmuzhi.com/logo.png',
        success: function () {
          // 设置成功
        },
      });

      // 分享到朋友圈
      wx.updateTimelineShareData({
        title: '山木枝（河北）技术服务有限公司',
        link: window.location.href,
        imgUrl: 'http://www.shanmuzhi.com/logo.png',
        success: function () {
          // 设置成功
        },
      });
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setRem);
  },
  computed: {
    isMobileByWidth() {
      // 使用响应式数据 windowWidth 代替直接访问 window.innerWidth
      return this.windowWidth < 768;
    },
  },
  watch: {
    $route: function (to, from) {
      // if (
      //   window.localStorage.user_name !== undefined &&
      //   window.localStorage.user_name !== null &&
      //   window.localStorage.user_name !== ''
      // ) {
      //   this.name = window.localStorage.user_name
      //   this.isLogin = true
      // } else {
      //   this.name = ''
      //   this.isLogin = false
      // }
      this.active_page = to.path;
    },
  },
  methods: {
    async getSign() {
      pageApi.getWxShareSign().then((res) => {
        wx.config({
          ...res.result,
        });
      });
    },
    setRem(isMobile) {
      let currentDevice = this.isMobileByWidth;
      console.log(isMobile, '是否是移动端');
      // 更新窗口宽度
      this.windowWidth = window.innerWidth;
      // 根据设备类型设置不同的设计稿宽度
      const designWidth = currentDevice ? 750 : 1920;
      const remPx = 16;
      // 计算缩放比例
      const scale = this.windowWidth / designWidth;
      // 设置根元素字体大小
      document.documentElement.style.fontSize = scale * remPx + 'px';
      // 可选：添加移动端类名，方便样式适配
      // document.documentElement.classList.toggle('mobile', isMobile)
    },
    listenMobile() {
      console.log('this.listenMobile', this.isMobile);
      setTimeout(() => {
        // 当前路由名称
        const currentRouteName = this.$route.name || '';
        const currentPath = this.$route.path;
        if (this.isMobile) {
          // 如果是移动端
          if (
            !currentRouteName.includes('phone') &&
            !currentRouteName.includes('phone')
          ) {
            // 当前不是移动端路由，需要跳转到对应的移动端路由
            const routeName = currentRouteName
              ? `phone-${currentRouteName}`
              : 'phone-index';
            const routePath = currentRouteName
              ? `/phone/${currentRouteName}`
              : '/phone/index';
            this.$router.replace({
              name: routeName,
              path: routePath,
            });
          }
        } else {
          // 如果是PC端
          if (currentRouteName.startsWith('phone-')) {
            // 当前是移动端路由，需要跳转到对应的PC端路由
            const routeName = currentRouteName.replace('phone-', '');
            const routePath = currentPath.replace('/phone/', '/');
            this.$router.replace({
              name: routeName || 'home',
              path: routePath || '/',
            });
          }
        }
      }, 10);
    },
  },
};
</script>
<style>
/* 适配走马灯指示灯样式 */
.el-carousel__indicators--outside .is-active .el-carousel__button {
  background-color: #ffcfa0 !important;
}

/* 打字光标去除 */
.typed-cursor.typed-cursor--blink {
  display: none !important;
}
.typed-cursor {
  display: none !important;
}
textarea {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border: none !important;
  font-weight: 400 !important;
  font-size: 1.75rem !important;
  color: #ffffff !important;
}
</style>
